import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { removeQuery } from 'Helpers/Query';
import { Dialog, DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { component } from 'Helpers/PropTypes';

const styles = () => ({
  root: {},
  title: {
    display: 'flex',
    padding: 0,
    justifyContent: 'flex-end',
  },
});

const TabPopoutModal = ({
  className,
  classes,
  Component,
}) => {
  const toggleOffModal = () => {
    removeQuery('modal', 'poppedOutTab');
  };

  return (
    <Dialog
      maxWidth="xl"
      open
      onClose={toggleOffModal}
      className={classNames(className, classes.root)}
    >
      <DialogTitle className={classes.title}>
        <IconButton onClick={toggleOffModal}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Component />
    </Dialog>
  );
};

TabPopoutModal.defaultProps = {
  className: '',
};

TabPopoutModal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  Component: component.isRequired,
};

export default withStyles(styles)(TabPopoutModal);
